<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item>
                <el-radio-group v-model="pgData.issh" @change="searchHandler">
                    <el-radio-button label="0">未核实单位</el-radio-button>
                    <el-radio-button label="1">已核实单位</el-radio-button>
                </el-radio-group>
            </el-form-item>
            
            <el-form-item>
                <el-input
                    v-model="pgData.txtKey1"
                    placeholder="购标单位名称"
                    clearable
                ></el-input>
            </el-form-item>

            <span slot="title"></span>
            <span slot="time"></span>
            <template slot="btn">
                <el-button 
                type="warning" 
                icon="el-icon-download" 
                @click="downloadExcelHandler">
                    导出excel
                </el-button>

                <el-button 
                v-if="pgData.issh === '0'"
                type="warning" 
                icon="el-icon-finished" 
                @click="batchAudit">
                    批量核实收款
                </el-button>
            </template>
        </my-search>

        <my-table 
        :data="tableData" 
        :height="tableHeight" 
        v-model="tableSelect"
        :select="pgData.issh === '0'"
        >

            <el-table-column label="订单编号" prop="orderscode" fixed sortable min-width="200"></el-table-column>
            <el-table-column label="购标单位" prop="tbdwname" sortable min-width="150"></el-table-column>
            <el-table-column label="联系人" prop="tblxr" min-width="120">
                <template v-slot="scope">
                    {{scope.row.tblxr}}
                    （{{scope.row.mobile}}）
                </template>
            </el-table-column>
            <el-table-column label="购标日期" prop="gbdate" sortable min-width="180"></el-table-column>
            <el-table-column label="招标项目名称" prop="zbproname" min-width="150"></el-table-column>

            <el-table-column label="付款金额" prop="orderssum" sortable min-width="150"></el-table-column>
            <el-table-column label="付款时间" prop="auditdate" sortable min-width="180">
                <template v-slot="scope">
                    {{scope.row.auditdate || '-'}}
                </template>
            </el-table-column>

            <el-table-column label="备注" prop="auditcontent" min-width="150">
                <template v-slot="scope">
                    {{scope.row.auditcontent || '-'}}
                </template>
            </el-table-column>

            <el-table-column label="开票状态" prop="orderscode" min-width="150">
                <template slot-scope="scope"> 
                    <span v-if="scope.row.auditstatus == '1' && scope.row.fkfs == '9' && (scope.row.fpbj && scope.row.fpbj!= '0')">
                        开票时间：{{scope.row.fptime}}
                    </span>
                    <span v-else>
                        -
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="状态" prop="fkfs" min-width="180">
                <template slot-scope="scope">
                    <state-list 
                        :row="scope.row" 
                        :config="STATE_CONF"
                    ></state-list>
                </template>
            </el-table-column>

            <el-table-column label="付款方式" prop="fkfs" min-width="160" fixed="right">
                <template slot-scope="scope">
                    <fkfs 
                        :key="scope.row.orderscode"
                        :row="scope.row" 
                        @showfile="showFileHandler(scope.row)"
                    ></fkfs>
                </template>
            </el-table-column>

            <el-table-column label="核实" width="350" fixed="right">
                <template slot-scope="scope">
                    <btn-list
                        :row="scope.row" 
                        @reload="reloadHandler"
                        :config="BTN_CONF"
                    ></btn-list>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/manage/finance/auditbsk/gkzb-gmbs/get_bslist.json`">
        </my-pagination>

        <my-dialog v-model="fileDialogVisible" title="凭证">
            <my-upload 
                v-if="fileDialogVisible"
                readonly
                :file-guid="fileEditRow.fileguid || ''"
            ></my-upload>
        </my-dialog>

        <my-dialog title="批量核实" v-model="dialogVisible">
            <form-audit 
                v-if="dialogVisible"
                :row="dialogData"
                @cancle="dialogCancleHandler"
            ></form-audit>
        </my-dialog>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import Fkfs from './components/fkfs'

import STATE_CONF from './config/bsk-state'
import BTN_CONF from './config/bsk-btn-list'

import FormAudit from './sub-pages/form-audit'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: { Fkfs, FormAudit },
    data() {
        return {
            pgData: {
                sortname: 'gbdate',
                sortorder: 'desc',
                
                bdcode: this.getQuery('bdcode'),

                issh: '0',
                txtKey1: '',
            },

            fileDialogVisible: false,
            fileEditRow: {},

            tableSelect: [],

            STATE_CONF,
            BTN_CONF,

            dialogVisible: false,
            dialogData: '',
        }
    },
    computed: {
        bdcode() {
            return this.getQuery('bdcode')
        }
    },
    watch: {
        dialogVisible(n) {
            if(!n) {
                this.reloadHandler();
            };
        }
    },
    methods: {
        batchAudit() {
            if(!this.tableSelect.length) {
                ShowMsg('请选择需要批量核实的项', 'warning');
                return;
            }

            var orderscode = this.tableSelect.map(item => item.orderscode).join(',');
            this.dialogData = {
                orderscode
            };
            this.dialogVisible = true;
        },

        dialogCancleHandler(){
            this.dialogVisible = false;
        },

        showFileHandler(row) {
            this.fileEditRow = row;
            this.fileDialogVisible = true;
        },
        downloadExcelHandler() {
            var tbdwname = this.pgData.tbdwname,
                issh = this.pgData.issh,
                bdcode = this.bdcode;

            window.win.g({
                path: `${this.getGetters('mngUrl')}/manage/finance/auditbsk/exportbskexcel`,
                query: {
                    txtKey1: tbdwname,
                    issh,
                    type: 'gkzb-gmbs',
                    bdcode,
                }
            })
        },
    },
    created() {
        // this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/gkzb-gmbs/bslist.json`, {
        //     bdcode: this.bdcode
        // }, data => {});
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
</style>
